import { map } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '../services/config.service';

@Pipe({
  name: 'locationNameFromId',
  standalone: true
})
export class LocationNameFromIdPipe implements PipeTransform {
  constructor(private configService: ConfigService) {}

  transform(value: any, args?: any): any {
    return this.configService.locations.pipe(
      map((locations) => {
        let name: string = '';
        if (!locations) {
          return name;
        }
        locations.forEach((location) => {
          if (location.id === parseInt(value, 10)) {
            name = location.name;
          }
        });
        return name;
      })
    );
  }
}
